import React, { useState } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '"10 minutes, c\'est vraiment suffisant ?"',
  answer: "Oui. Et c'est exactement pourquoi ça marche. Si c'était 45 minutes, tu ne le ferais pas. On le sait toutes les deux. 10 minutes, c'est le temps d'une pub pendant ta série. C'est faisable. Ce soir."
}, {
  question: '"Je ne suis pas douée en technologie."',
  answer: "Si tu utilises Facebook ou si tu envoies des photos à ta mère sur son téléphone... Tu as toutes les compétences nécessaires. C'est du copier-coller. Rien de plus."
}, {
  question: '"Je suis maman solo. C\'est adapté pour moi ?"',
  answer: "J'ai écrit un chapitre entier rien que pour toi. Quand tu portes tout seule, un système n'est pas un luxe. C'est une ligne de vie."
}, {
  question: '"Et si ça ne marche pas pour moi ?"',
  answer: 'Lis juste en dessous.'
}];
export function FAQSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full py-14 md:py-24 px-6 relative" style={{
    background: '#0D1B2A'
  }} data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-23">
          <div className="amber-divider mb-8 md:mb-12" data-id="element-24" />

          <h2 className="text-2xl md:text-4xl font-bold text-center mb-10 md:mb-16" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-25">
            Tes questions
          </h2>

          <div className="space-y-3 md:space-y-4" data-id="element-26">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <div key={index} className="rounded-xl overflow-hidden transition-colors" style={{
              background: isOpen ? 'rgba(212,168,83,0.08)' : 'rgba(255,255,255,0.03)',
              border: `1px solid ${isOpen ? 'rgba(212,168,83,0.3)' : 'rgba(255,255,255,0.06)'}`
            }} data-id="element-27">
                  <button onClick={() => toggle(index)} className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer" data-id="element-28">
                    <span className="text-base md:text-lg font-bold" style={{
                  fontFamily: 'Playfair Display, serif',
                  color: '#D4A853'
                }} data-id="element-29">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className="flex-shrink-0 transition-transform duration-300" style={{
                  color: '#D4A853',
                  width: 20,
                  height: 20,
                  transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                }} data-id="element-30" />
                  </button>

                  <div className="overflow-hidden transition-all duration-300 ease-in-out" style={{
                maxHeight: isOpen ? '300px' : '0px',
                opacity: isOpen ? 1 : 0
              }} data-id="element-31">
                    <p className="px-6 pb-5 leading-relaxed" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#C8C0B0'
                }} data-id="element-32">
                      {faq.answer}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}